import { noop } from '@kofno/piper';
import { previewStore } from '../../../../../LearningCollectionPreviewStore';
import BaseLayout from '../../../../../../shared/SaveActions/BaseLayout';
import CancelButton from '../../../../../../shared/SaveActions/CancelButton';
import PublishButton from '../../../../../../shared/SaveActions/PublishButton';
import CancelModal from './CancelModal';
import OtherCreateOptions from './OtherCreateOptions';

export function ConfirmingCancelState() {
  return (
    <BaseLayout>
      <CancelButton onClick={() => previewStore.showCancelConfirmation()} />
      <div className="flex items-center">
        <PublishButton onClick={noop} />
        <OtherCreateOptions />
      </div>
      <CancelModal />
    </BaseLayout>
  );
}
